import React from 'react'
import ObjectList from './ObjectList'
import Breadcrumb from './Breadcrumb'
import Loading from './Loading'
import useData from '../hooks/useData'
import Flag from './Flag'
// import SearchConsoleSite from './SearchConsoleSite'

let component_mounted = false
const model = 'site'

const SiteView = (props) => {
    const id = props.id || (props.match && props.match.params && props.match.params.id) || false
    const siteData = useData(model + '/' + id + '?scope=view')
    const site = siteData.data

    const unavailableLinkData = useData('provider/amazon/unavailable_links?scope=list&site_id=' + id, [id])

    return (
        <React.Fragment>
            {(siteData.isReady && (
                <React.Fragment>
                    {/* <Breadcrumb breadcrumb_data={[{ icon: 'site', label: site.data.label, href: '/site/view/' + id }]} /> */}
                    <h2>{site.label}</h2>
                    <p className="mb-0">
                        <Flag locale={site.locale} className="mr-2" />
                        {site.url}
                    </p>
                    <div className="mb-3">
                        <p className="mb-0">
                            {site.articles_count} article{(site.articles_count != 1 && 's') || ''}
                        </p>

                        <p className="mb-0">
                            <small>
                                {(unavailableLinkData.data?.length && (
                                    <>
                                        {unavailableLinkData.data?.length} unavailable link{(unavailableLinkData.data?.length != 1 && 's') || ''}
                                    </>
                                )) ||
                                    ' '}
                            </small>
                        </p>
                    </div>
                    {/* <SearchConsoleSite id={id} /> */}
                    <ObjectList model="article" filter={'site_id=' + id} />
                </React.Fragment>
            )) || <Loading text="Fetching site data" />}
        </React.Fragment>
    )
}

export default SiteView
